export default __webpack_public_path__ + "static/media/wagtail.2dc2ee3c.svg";